import React from 'react';
import Validator from "../validator";
import {renderRichText} from "gatsby-source-contentful/rich-text";

function ListOfValidators(props) {
    return (
        <section key={props.key} className="validators-list-section">
            <div className="container border-bottom">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6 order-2 order-md-1">
                        <div className="row align-items-center">
                            {props.content.images && props.content.images.map((element, index) => {
                                return(
                                    <Validator content={element} key={index}/>
                                )
                            })}
                        </div>
                    </div>
                    <div className="col-12 col-md-5 offset-md-1 order-1 order-md-2 pb-5 pb-md-0">
                        <h2>{props.content.title}</h2>
                        <div className={'text'}>
                            {renderRichText(props.content.body)}
                        </div>
                        <a href={props.content.ctaUrl} target="_blank" rel="noreferrer" className="btn d-table">
                            {props.content.ctaText}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ListOfValidators;
